<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar class="formCard" style="border-radius: 5px !important; padding-left: 0px" toggleable="lg" type="dark"
          variant="primary">
          <b-navbar-nav>
            <b-button @click="goBack" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
            </b-button>
          </b-navbar-nav>
          <b-navbar-brand center>{{ $route.name }}</b-navbar-brand>
          <b-navbar-nav class="ml-auto">
            <b-nav-form> </b-nav-form>
          </b-navbar-nav>
        </b-navbar>
        <b-card class="formCard">
          <b-card-text>

            <StatusAlerts :SUBS_alerts="alerts" />
            <ContainerDetails :getSingleShipments="getSingleShipments" />
            <!-- MapComponent would go here, but it's complex and requires a mapping library -->
            <!-- <DetailsTab /> -->
          </b-card-text>
        </b-card>
      </b-card-text>
    </b-card>

    <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-alert>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import { ModelListSelect } from "vue-search-select";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import { globalPermissionStatus } from "../../helper/collection";
import OceanInsightsSubscriptionService from "../../services/OceanInsightsSubscriptionService.js";
import moment from "moment";
import ContainerDetails from "./ContainerDetails.vue";
import StatusAlerts from "./StatusAlerts.vue";
import DetailsTab from "./DetailsTab.vue";
import CustomLoader from "../common/customLoader.vue";
export default {
  beforeMount() {
    if (globalPermissionStatus("Dashboard_Access")) {
      this.$store.dispatch(
        "setCurrentRoute",
        "/tracking/ocean-insights/affectedCont/" + this.$route.params.shipment_id
      );
      this.getSingleShipmentsFunc();
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },
  data() {
    return {
      alerts: [],
      ExcelBtnName: "Export As Excel",
      totalRows: 0,
      currentPage: 1,
      perPage: 1000,
      pageOptions: [20, 50, 100],
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      getSingleShipments: {},

      docURL: URL_BASE_DOC,
      alert: {
        content: "Added Succesfully",
        ok: "ok",
      },
      lastVisitPage: this.$sessionsStorage.get("lastVisitPage"),
      isLoading: false,
      Filter: "",
    };
  },

  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  mounted() {},

  beforeDestroy() {},

  destroyed() {},

  components: {
    DatePicker,
    ModelListSelect,
    Loading,
    ContainerDetails,
    StatusAlerts,
    DetailsTab,
    CustomLoader,
  },
  watch: {},

  computed: {
    podDischargePrediction(data) {
      return data;
    },
  },
  methods: {
    getShipmentSubscription(item, type) {
      console.log(type, " ", item);
      if (type == "Subscription") {
        this.$router.push({
          path: "/tracking/ocean-insights/subscription/" + item.shipmentsubscription_id,
        });
      } else if (type == "Shipment") {
        this.$router.push({
          path: "/tracking/ocean-insights/shipment/" + item.id,
        });
      }
    },
    daysDifference(created, predicted) {
      let daysDifference = 0;
      if (created && predicted) {
        const createdDate = new Date(created);
        const predictedDate = new Date(predicted);

        // Calculate the time difference in milliseconds
        const timeDifference = predictedDate - createdDate;

        // Convert the time difference to days
        daysDifference = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
      }
      return daysDifference;
    },
    async getSingleShipmentsFunc() {
      let payload = {};
      this.isLoading = true;
      this.getSingleShipments = {};
      payload = {
        itemCode: "getSingleShipments",
        shipment_id: this.$route.params.shipment_id,
        page_size: this.cont_count,
      };

      payload = JSON.stringify(payload);

      OceanInsightsSubscriptionService.getAllOceanInsightList(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
            this.isLoading = false;
            console.log("getSingleShipments PS =>", data);

            if (data.getSingleShipments) {
              this.getSingleShipments = data.getSingleShipments;
              if (this.getSingleShipments.pod_timeofarrival_warning) {
                let type;
                if (this.getSingleShipments.pod_timeofarrival_warning.risk == 2 || this.getSingleShipments.pod_timeofarrival_warning.risk_verbose == "High Risk") {
                  type = "alert-danger-text";
                }
                if (this.getSingleShipments.pod_timeofarrival_warning.risk_verbose == "Low Risk") {
                  type = "alert-warning";
                }
                if (this.getSingleShipments.pod_timeofarrival_warning.risk_verbose == "No Risk") {
                  type = "alert-info-text";
                }
                this.alerts.push({
                  id: this.getSingleShipments.pod_timeofarrival_warning.risk,
                  type: type,
                  risk_verbose: this.getSingleShipments.pod_timeofarrival_warning
                    .risk_verbose,
                  title: this.getSingleShipments.pod_timeofarrival_warning.risk_verbose,
                  message: this.getSingleShipments.pod_timeofarrival_warning
                    .risk_description,
                  conclusion: this.getSingleShipments.pod_timeofarrival_warning
                    .conclusion,
                },
                {
                  id: this.getSingleShipments.pod_timeofarrival_warning.risk+1,
                  type: 'alert-info-text',
                  risk_verbose: this.getSingleShipments.pod_timeofarrival_warning
                    .risk_verbose,
                  title: "Conclusion",
                  message: this.getSingleShipments.pod_timeofarrival_warning
                    .conclusion,
                  conclusion: this.getSingleShipments.pod_timeofarrival_warning
                    .conclusion,
                });
              }
            }
            console.log("getSingleShipments PS =>", this.getSingleShipments.length);
          }
        })
        .catch((error) => {
          console.log("Catch on getSingleShipments Error: ", error);
        });
    },

    goBack() {
      window.history.go(-1);
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// affectedShipmentCont.vue?d80198ca